import { CollapsedSection } from "@/components/admin/CollapsedSection";
import { QcMailRecipients } from "@/components/admin/QcMailRecipients";
import { useAuth } from "@/contexts/AuthContext";

export function BuilderAssistantQcRoster() {
  const auth = useAuth();
  const canCurate = auth.hasRole("admin", "owner", "org_admin", "org_owner", "platform_admin", "platform_owner", "platform_dev");
  if (!canCurate) return null;
  return (
    <CollapsedSection title="Email recipients">
      <QcMailRecipients />
    </CollapsedSection>
  );
}
